import { connect } from "react-redux";
import { Policies } from "../components/Policies/Policies";
import * as constants from "../constants/clients.constants";

const mapStateToProps = (state: any) => {
	return {
		policyPivacy: state.client.policyPivacy,
		policyShipping: state.client.policyShipping,
		policyReturn: state.client.policyReturn,
		userConfig: state.auth.userConfig,
	};
};

const mapDispatchToProps = (dispatch: any) => {
	return {
		getPolicies: (config: any) =>
			dispatch({type: constants.GET_POLICIES_REQUEST,	value: config})
		
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(Policies);
